import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.23926 2.15039L3.49365 3.45264L5.44482 4.57031L6.19189 3.26953L4.23926 2.15039ZM19.7607 2.15039L17.8081 3.26953L18.5552 4.57031L20.5063 3.45264L19.7607 2.15039ZM12 2.25C9.10925 2.25 6.75 4.60925 6.75 7.5V15H5.25V16.5H6.97412C7.25076 17.1558 7.84269 18.1891 9 18.8203V19.5C9 20.3198 9.6802 21 10.5 21L11.25 21.75H12.75L13.5 21C14.3198 21 15 20.3198 15 19.5V18.8203C16.1573 18.1891 16.7492 17.1558 17.0259 16.5H18.75V15H17.25V7.5C17.25 4.60925 14.8908 2.25 12 2.25ZM12 3.75C14.0802 3.75 15.75 5.41975 15.75 7.5V15H8.25V7.5C8.25 5.41975 9.91975 3.75 12 3.75ZM3 6V7.5H5.25V6H3ZM18.75 6V7.5H21V6H18.75ZM5.04639 9.02783L2.94287 9.62256L3.35156 11.0669L5.45361 10.4722L5.04639 9.02783ZM18.9565 9.0293L18.5435 10.4707L20.6206 11.0654L21.0337 9.62402L18.9565 9.0293ZM8.6001 16.5H15.3999C15.1368 16.9532 14.7025 17.4597 13.9966 17.7129L13.5 17.8901V19.5H10.5V17.8901L10.0034 17.7129C9.29746 17.4597 8.8632 16.9532 8.6001 16.5Z",
		fill: "currentColor"
	})
});
export default SvgLight;
